import {
  Accordion,
  Attribute,
  Button,
  CustomMobileAccordionType,
  Icon,
  MobileAccordionSelection,
  Typography,
  createCssVariableString,
} from "best-common-react";
import React from "react";
import styled from "styled-components";
import type { EventAccessData } from "./EventAccess";

const StrikeThrough = styled(Typography)`
  text-decoration: line-through;
  color: ${createCssVariableString("onColorsOnSurfaceLow")};
`;

const OverrideValue = ({ value, override }: { value: string | null; override: string | null }) =>
  !override ? (
    <Typography>{value}</Typography>
  ) : (
    <>
      <Typography>{override}</Typography>
      <StrikeThrough>{value}</StrikeThrough>
    </>
  );

const EventAccessAccordion = ({
  data: { override, department, access, personalCutoff, businessCutoff, personalRequests },
  index,
  ...rest
}: CustomMobileAccordionType<EventAccessData>) => (
  <Accordion {...rest}>
    <Accordion.Header>
      <div className="d-flex align-items-center justify-content-between bcr-gap-2 w-100">
        <div className="d-flex align-items-center bcr-gap-1">
          <MobileAccordionSelection index={index} className="bcr-me-2" />
          <Typography>{department}</Typography>
        </div>
        {override.isOverride ? (
          <div className="d-flex align-items-center bcr-gap-2">
            <Button variant="link" onClick={() => override.onEdit(override.department)}>
              Edit Override
            </Button>
            <Icon iconName="fa-trash-alt" className="fa-lg" onClick={() => override.onDelete(override.department)} />
          </div>
        ) : (
          <Button variant="link" onClick={() => override.onAdd(override.department)}>
            Add Override
          </Button>
        )}
      </div>
    </Accordion.Header>
    <Accordion.Body>
      <div className="bcr-px-2">
        <Attribute
          horizontal
          header="Event Access (local time)"
          value={<OverrideValue value={access.time} override={access.override} />}
          className="justify-content-between bcr-py-1"
        />
        <Attribute
          horizontal
          header="Personal Event Cutoff (local time)"
          value={<OverrideValue value={personalCutoff.time} override={personalCutoff.override} />}
          className="justify-content-between bcr-py-1"
        />
        <Attribute
          horizontal
          header="Business Event Cutoff (local time)"
          value={<OverrideValue value={businessCutoff.time} override={businessCutoff.override} />}
          className="justify-content-between bcr-py-1"
        />
        <Attribute
          horizontal
          header="Personal Requests"
          value={
            personalRequests.override === null ? (
              <Typography>{personalRequests.enable ? "On" : "Off"}</Typography>
            ) : (
              <>
                <Typography>{personalRequests.override ? "On" : "Off"}</Typography>
                <StrikeThrough>{personalRequests.enable ? "On" : "Off"}</StrikeThrough>
              </>
            )
          }
          className="justify-content-between bcr-py-1"
        />
      </div>
    </Accordion.Body>
  </Accordion>
);

export default EventAccessAccordion;
